// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"eR-z","categoryName":"fR-z","categoryNameSearchHeader":"gR-z","categoryContent":"hR-z","bottomAligned":"iR-z","image":"jR-z","imageNoBackground":"kR-z"};